import { PriceGroupType } from "shared/types/Price"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapPriceGroupName(groups: any[], id: string) {
  return groups.map(group => {
    if (group.groupType === PriceGroupType.ORIGINAL) {
      return { ...group, name: group.parentPriceGroup, id: `${id}-${group.id}` }
    }
    if (group.groupType === PriceGroupType.SPECIAL) {
      return { ...group, name: group.productType }
    }
    return group
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapSpecialPriceGroupName(groups: any[]) {
  return groups.map(group => {
    return { ...group, name: group.productType }
  })
}
